import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Button.scss'

import { ButtonLoader } from '../Loader'

class Button extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: props.loading
		}
	}
	componentWillReceiveProps(nextProps) {
		const currentLoading = this.props.loading
		const loading = nextProps.loading

		if (currentLoading) {
			clearTimeout(this.delayTimeout)
		}

		if (loading) {
			this.delayTimeout = setTimeout(
				() => this.setState({ loading }),
				200
			)
		} else {
			this.setState({ loading })
		}
	}
	componentWillUnmount() {
		if (this.timeout) {
			clearTimeout(this.timeout)
		}
		if (this.delayTimeout) {
			clearTimeout(this.delayTimeout)
		}
	}
	handleClick = e => {
		this.setState({ clicked: true })
		clearTimeout(this.timeout)
		this.timeout = setTimeout(() => this.setState({ clicked: false }), 150)

		const onClick = this.props.onClick

		if (onClick && !this.state.loading) {
			onClick(e)
		}
	}
	render() {
		const { loading, clicked } = this.state
		const { icon, size, htmlType, type, children, disabled } = this.props

		const isLoading = loading ? styles.loading : ''
		const isClicked = clicked ? styles.clicked : ''
		const isDisabled = disabled ? styles.disabled : ''

		const setHtmlType = htmlType ? htmlType : 'button'
		const setType = type ? type : 'default'

		const setSize = size => {
			switch (size) {
				case 'large':
					return styles.large
				case 'small':
					return styles.small
				default:
					return ''
			}
		}

		return (
			<button
				styleName={'button-' + setType}
				type={setHtmlType}
				className={[
					isLoading,
					isClicked,
					isDisabled,
					setSize(size)
				].join(' ')}
				onClick={this.handleClick}
				onTouchStart={this.handleClick}
				disabled={disabled || loading}
			>
				<span styleName="wrapper">
					{children ? <span styleName="label">{children}</span> : ''}
					{isLoading ? <ButtonLoader /> : ''}
					{icon && !isLoading ? (
						<i className="material-icons" styleName="icon">
							{icon}
						</i>
					) : (
						''
					)}
				</span>
			</button>
		)
	}
}

// const ButtonType = 'primary' | 'danger'

Button.defaultProps = {
	loading: false,
	clicked: false
}

Button.propTypes = {
	onClick: React.PropTypes.func,
	loading: React.PropTypes.bool
}

export default CSSModules(Button, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Button/Button.js